import z from 'zod';
import { defineObject } from 'sanity-typed-queries';
var schema = defineObject('scrollAnchorSection', {
    id: {
        title: 'ID',
        type: 'string',
        validation: function validation(Rule) {
            return Rule.regex(/^[a-zA-Z0-9_-]+$/);
        }
    }
});
var validator = z.object({
    _type: z.literal('scrollAnchorSection'),
    id: z.string().optional()
});
schema.scrollAnchorSection;
export default {
    schema: schema,
    validator: validator
};

//# sourceMappingURL=scrollAnchorSection.js.map